module.exports = __webpack_public_path__ + "assets/img/course_big_cat6.e4e1a6dc.png";